const ITEMS = [
  "One Contractor",
  "Multiple Disciplines",
  "Safety First",
  "Built for Industry",
  "Mechanical · Steel · Civil · Coatings",
  "Traditional Industry to Mission-Critical",
];

export default function Marquee() {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-condensed uppercase tracking-[0.25em] text-lg md:text-xl font-semibold text-white/70 px-8">
            {t}
          </span>
          <span className="h-1.5 w-1.5 bg-gig-red rotate-45" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className="overflow-hidden border-y border-white/10 bg-gig-black py-5"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
}
